import { render, staticRenderFns } from "./AuthToolUpdateBox.vue?vue&type=template&id=56bf38ed"
import script from "./AuthToolUpdateBox.vue?vue&type=script&lang=js"
export * from "./AuthToolUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports